import React from 'react';
import { Tooltip } from '../ToolTip/ToolTip';
import { Icons } from '../Icons';
import FileIcon from '../../../assets/FileIcon.svg';

/**
 * UploadedFileItem — Displays file info after a successful upload.
 *
 * Shows the file icon, file name (truncated if long), file size,
 * and a remove button to clear the selection.
 *
 * @param {string} fileName    - Name of the uploaded file
 * @param {string} fileSize    - Formatted file size (e.g. "2.4 MB")
 * @param {func}   onRemove    - Callback to remove/reset the file
 * @param {string} customClass - Additional CSS classes
 */
export const UploadedFileItem = ({ fileName, fileSize, onRemove, customClass = "", customStyle = {} }) => {
    return (
        <div className={`uploaded-file-item ${customClass}`} style={customStyle}>
            <div className="file-info-container">
                <img src={FileIcon} alt="file icon" className="file-icon" />
                <div className="file-details">
                    <Tooltip tooltipText={fileName} placement="top" wrapperStyle={{ display: 'block', width: '100%', minWidth: 0 }}>
                        <span className="file-name body-s-bold">{fileName}</span>
                    </Tooltip>
                    <span className="file-size body-s">
                        {fileSize}
                    </span>
                </div>
            </div>

            <div className="close_button" onClick={onRemove}>
                <Icons name="close" size={16} />
            </div>
        </div>
    );
};

export default UploadedFileItem;
